module.exports = __webpack_public_path__ + "media/images/img09-1c92c1b8f037a3bca66b647672e115d1.png";